var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHrSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2352_24388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0971 28.4051C29.9704 28.4051 32.2996 26.0758 32.2996 23.2026C32.2996 20.3293 29.9704 18 27.0971 18C24.2238 18 21.8945 20.3293 21.8945 23.2026C21.8945 26.0758 24.2238 28.4051 27.0971 28.4051Z",
    fill: "#F7A010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0929 28.4058C22.6234 28.4058 19 32.0287 19 36.4986H35.1856C35.1856 32.0287 31.5622 28.4058 27.0929 28.4058Z",
    fill: "#F7A010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2677 55.7304L48.6253 45.0879C52.6032 40.3174 55 34.1848 55 27.5024C55 12.3389 42.6635 0.00244141 27.5 0.00244141C12.3365 0.00244141 0 12.3388 0 27.5024C0 42.6661 12.3365 55.0024 27.5 55.0024C34.1845 55.0024 40.319 52.6039 45.0902 48.6239L55.7323 59.2661C56.2205 59.7543 56.8603 59.9983 57.5 59.9983C58.1397 59.9983 58.7797 59.7543 59.2677 59.2661C60.2442 58.2896 60.2442 56.7068 59.2677 55.7304ZM5 27.5024C5 15.0959 15.0935 5.00244 27.5 5.00244C39.9065 5.00244 50 15.0959 50 27.5024C50 39.9089 39.9065 50.0024 27.5 50.0024C15.0935 50.0024 5 39.9089 5 27.5024Z",
    fill: "#044D9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2352_24388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrSmall);
export default __webpack_public_path__ + "static/media/hrSmall.16a3a8dbc8aa997b9d568e0096dfb409.svg";
export { ForwardRef as ReactComponent };